/**
 * 客户端请求头管理工具
 * 用于获取客户端传递给H5的请求头数据，并添加到全局请求头中
 */

/**
 * 获取客户端请求头
 * @returns {Promise<Record<string, string>>} 返回客户端请求头对象
 */
export const getClientHeaders = (): Promise<Record<string, string>> => {
  return new Promise((resolve) => {
    try {
      // 设置回调函数
      (window as any).getRequestHeaderSuccess = (result: any) => {
        console.log('获取到客户端请求头:', result);

        try {
          // 处理result，确保是对象格式
          let headers: Record<string, string> = {};

          if (result) {
            // 如果result是字符串，尝试解析为JSON
            if (typeof result === 'string') {
              try {
                headers = JSON.parse(result);
              } catch (parseError) {
                console.warn('解析客户端请求头JSON失败:', parseError);
                headers = {};
              }
            } else if (typeof result === 'object') {
              headers = result;
            }
          }

          console.log('处理后的客户端请求头:', headers);
          resolve(headers);
        } catch (error) {
          console.error('处理客户端请求头失败:', error);
          resolve({});
        }
      };

      // 调用客户端方法获取请求头
      if (typeof window !== 'undefined' && window.jhsapp && typeof window.jhsapp.handleEvent === 'function') {
        window.jhsapp.handleEvent(JSON.stringify({
          action: "getRequestHeader",
          param: {},
          successCallback: "getRequestHeaderSuccess"
        }));
      } else {
        console.log('jhsapp.handleEvent 方法不可用');
        resolve({});
      }

      // 设置超时，防止客户端无响应
      setTimeout(() => {
        console.warn('获取客户端请求头超时，使用空对象');
        resolve({});
      }, 3000);
    } catch (error) {
      console.error('获取客户端请求头失败:', error);
      resolve({});
    }
  });
};

